var _filter;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadmapScaleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_5381)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_222_5381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 22.6668H25.3337V16.0002H22.667V20.0002H18.667V22.6668ZM6.66699 16.0002H9.33366V12.0002H13.3337V9.3335H6.66699V16.0002ZM5.33366 26.6668C4.60033 26.6668 3.97255 26.4057 3.45033 25.8835C2.9281 25.3613 2.66699 24.7335 2.66699 24.0002V8.00016C2.66699 7.26683 2.9281 6.63905 3.45033 6.11683C3.97255 5.59461 4.60033 5.3335 5.33366 5.3335H26.667C27.4003 5.3335 28.0281 5.59461 28.5503 6.11683C29.0725 6.63905 29.3337 7.26683 29.3337 8.00016V24.0002C29.3337 24.7335 29.0725 25.3613 28.5503 25.8835C28.0281 26.4057 27.4003 26.6668 26.667 26.6668H5.33366ZM5.33366 24.0002H26.667V8.00016H5.33366V24.0002Z",
    fill: "#5F6368",
    style: {
      fill: "#5F6368",
      fill: "color(display-p3 0.3725 0.3882 0.4078)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 22.6668H25.3337V16.0002H22.667V20.0002H18.667V22.6668ZM6.66699 16.0002H9.33366V12.0002H13.3337V9.3335H6.66699V16.0002ZM5.33366 26.6668C4.60033 26.6668 3.97255 26.4057 3.45033 25.8835C2.9281 25.3613 2.66699 24.7335 2.66699 24.0002V8.00016C2.66699 7.26683 2.9281 6.63905 3.45033 6.11683C3.97255 5.59461 4.60033 5.3335 5.33366 5.3335H26.667C27.4003 5.3335 28.0281 5.59461 28.5503 6.11683C29.0725 6.63905 29.3337 7.26683 29.3337 8.00016V24.0002C29.3337 24.7335 29.0725 25.3613 28.5503 25.8835C28.0281 26.4057 27.4003 26.6668 26.667 26.6668H5.33366ZM5.33366 24.0002H26.667V8.00016H5.33366V24.0002Z",
    fill: "url(#paint0_linear_222_5381)",
    style: {}
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_222_5381",
    x: -23.5418,
    y: -3.40275,
    width: 79.0845,
    height: 73.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.4725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.1044
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.172549 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_5381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_5381",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.86641
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2915
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92 0 0 0 0 1 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_222_5381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.36812
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18406
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_222_5381",
    result: "effect3_innerShadow_222_5381"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.944723,
    dy: 0.539842
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.607322
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_222_5381",
    result: "effect4_innerShadow_222_5381"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_5381",
    x1: 16.0003,
    y1: 5.3335,
    x2: 16.0003,
    y2: 26.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CDDA",
    style: {
      stopColor: "#00CDDA",
      stopColor: "color(display-p3 0.0000 0.8036 0.8549)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FFF00",
    style: {
      stopColor: "#8FFF00",
      stopColor: "color(display-p3 0.5600 1.0000 0.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_5381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapScaleIcon);
export default __webpack_public_path__ + "static/media/roadmap-scale-icon.dc62fd3a0e77bd17f3c627a70e0cb538.svg";
export { ForwardRef as ReactComponent };